import {Space} from "antd";
import {SessionGenInfoSessionLinkFormField} from "./session-link";
import {SessionGenInfoSessionDurationFormField} from "./session-duration";
import {SessionSubGenInfoFormFields} from "./sub-gen-info";

export function SessionGenInfoFormFields() {
  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      <SessionSubGenInfoFormFields
        coverImageFieldId="sessionCoverImage"
        coverImageFieldLabel="Cover Image"
        coverImageFieldPlaceholder=""
        descriptionFieldId="sessionDescription"
        descriptionFieldLabel="Session description"
        descriptionFieldPlaceholder="What is your session about"
        nameFieldId="sessionName"
        nameFieldLabel="Session name"
        nameFieldPlaceholder="e.g Marketing 101"
      />
      <SessionGenInfoSessionLinkFormField
        id={"sessionSlug"}
        label="Session Link"
        placeholder="30-min"
      />
      <SessionGenInfoSessionDurationFormField
        callDurationFormFieldId="sessionCallDuration"
        callDurationFormFieldLabel="Session Duration"
        callDurationFormFieldPlaceholder="Please select a duration"
        customCallDurationFormFieldId="sessionCustomCallDuration"
        customCallDurationFormFieldLabel="Custom Duration (in minutes)"
        customCallDurationFormFieldPlaceholder="120"
      />
    </Space>
  );
}
